import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import AppWrapper from "@/AppWrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: StrictMode removed due to incompatibility with Radix UI portals in React 19
// This causes "insertBefore" errors when portals are used with double-rendering
root.render(
  <AppWrapper />
);
